import { recoilKeys } from 'const';
import moment from 'moment';
import { atom } from 'recoil';

export const timeZoneState = atom({
  key: recoilKeys.TIME_ZONE,
  default: moment.tz.guess(),
});
